<template>
  <div class="wrapper signup-page">
    <!-- Header -->
    <Header />
    <!-- HeaderMenu -->
    <HeaderMenu />

    <div class="contents">
      <div class="layout">
        <div class="left"></div>
        <div class="right">
          <input class="c-checkbox" type="checkbox" id="start" />
          <input class="c-checkbox" type="checkbox" id="progress2" />
          <input class="c-checkbox" type="checkbox" id="progress3" />
          <input class="c-checkbox" type="checkbox" id="finish" />

          <input class="c-checkbox return-check" type="checkbox" id="return" />
          <input class="c-checkbox return-check" type="checkbox" id="return1" />
          <input class="c-checkbox return-check" type="checkbox" id="return2" />
          <input class="c-checkbox return-check" type="checkbox" id="return3" />

          <div class="shutter" style="display: none"></div>
          <div class="c-form__progress"></div>
          <h1>新規登録</h1>
          <p class="last-ttl">新規登録完了</p>
          <div class="user-name">
            <p>紹介者</p>
            <span>TESTUSER</span>
          </div>
          <div class="c-formContainer">
            <div class="c-welcome">
              早速ログインパスを<br />教えてあげよう!!
              <div class="img">
                <div class="link-btn link-over">
                  <img
                    src="../assets/img/signup-btn-img.svg"
                    alt=""
                    class="blink-animation"
                  />
                </div>
              </div>
            </div>
            <div class="btn">
              <form class="c-form" action="">
                <!-- 追加 -->
                <div class="c-form__group">
                  <p class="error-txt">このユーザー名は既に存在しています。</p>
                  <label class="c-form__label" for="username">
                    <input
                      type="text"
                      id="username"
                      class="c-form__input"
                      placeholder=" "
                      required
                    />
                    <label class="c-form__next" for="progress1" role="button">
                      <span class="c-form__nextIcon">
                        <img src="../assets/img/signin-arrow-img.svg" alt="" />
                      </span>
                    </label>

                    <span class="c-form__groupLabel">ユーザー名を入力</span>
                    <b class="c-form__border"></b>
                  </label>
                  <button class="return-txt" type="button">◀︎ Back</button>
                </div>
                <!-- ./追加 -->

                <!-- 2つ目 -->
                <div class="c-form__group">
                  <label class="c-form__label" for="password">
                    <input
                      type="password"
                      id="password"
                      class="c-form__input"
                      placeholder=" "
                      required
                    />
                    <label class="c-form__next" for="progress2" role="button">
                      <span class="c-form__nextIcon">
                        <img src="../assets/img/signin-arrow-img.svg" alt="" />
                      </span>
                    </label>

                    <span class="c-form__groupLabel">パスワード</span>
                    <b class="c-form__border"></b>
                  </label>
                  <button class="return-txt" type="button">◀︎ Back</button>
                </div>
                <!-- ./2つ目 -->

                <!-- 3つ目 -->
                <div class="c-form__group">
                  <label class="c-form__label" for="c-password">
                    <input
                      type="password"
                      id="c-password"
                      class="c-form__input"
                      placeholder=" "
                    />

                    <label class="c-form__next" for="progress3" role="button">
                      <span class="c-form__nextIcon"
                        ><img src="../assets/img/signin-arrow-img.svg" alt=""
                      /></span>
                    </label>

                    <span class="c-form__groupLabel">パスワードを再入力</span>
                    <b class="c-form__border"></b>
                  </label>
                  <button class="return-txt" type="button">◀︎ Back</button>
                </div>
                <!-- ./3つ目 -->

                <!-- 1つ目 -->
                <label class="c-form__toggle" for="start">登録する</label>
                <!-- ./1つ目 -->
              </form>
            </div>
          </div>
          <div class="fix-bar">
            <a href="./organizationchart" class="link-over">組織図に戻る</a>
          </div>
        </div>
      </div>
    </div>
    <!-- /.contents -->

    <Footer class="pc-only" title="Sign up2" />
  </div>
</template>

<style lang="less" scoped>
.header {
  /deep/ .grade {
    display: none !important;
  }
  /deep/ .detail {
    display: none !important;
  }
}
.signup-page {
  /deep/ .c-form__progress.progress1 {
    width: calc(100vw / 3);
  }
  /deep/ .c-form__progress.progress2 {
    width: calc((100vw / 3) + (100vw / 3));
  }
  /deep/ .c-form__progress.progress3 {
    width: 100vw;
    background-image: url(../assets/img/signup-progress-back-img.svg);
    background-size: contain;
    background-position: center;
  }
}
</style>

<script>
import $ from "jquery";
import Header from "@/components/Header.vue";
import HeaderMenu from "@/components/HeaderMenu.vue";
import Footer from "@/components/Footer.vue";
export default {
  name: "Signup2",
  components: {
    Header,
    HeaderMenu,
    Footer,
  },
  data: () => {
    return {
      userName: "",
      userTel: "",
    };
  },
  methods: {},
  computed: {
    hasUserName() {
      return this.userName;
    },
    hasUserTel() {
      return this.userTel;
    },
  },
  mounted: function () {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", vh + "px");

    var ua = navigator.userAgent.toLowerCase();
    var isiOS = ua.indexOf("iphone") > -1 || ua.indexOf("ipad") > -1;
    if (isiOS) {
      var viewport = document.querySelector('meta[name="viewport"]');
      if (viewport) {
        var viewportContent = viewport.getAttribute("content");
        viewport.setAttribute(
          "content",
          viewportContent + ", user-scalable=no"
        );
      }
    }

    $(".signup-page .c-form__toggle").on("click", function () {
      $(".fix-bar").fadeOut("slow");
    });
    $(".c-welcome .link-btn").on("click", function () {
      $(".shutter")
        .css("display", "block")
        .delay(2090)
        .queue(function () {
          location.href = "./";
          $(this).dequeue();
        });
    });

    $(".c-form__toggle").on("click", function () {
      $(".c-form__toggle").addClass("remove");
      $(".c-form__group:nth-child(1)").addClass("active");
    });
    $(".c-form__group:nth-child(1) .c-form__nextIcon").on("click", function () {
      $(".c-form__group:nth-child(1)").removeClass("active");
      $(".c-form__group:nth-child(2)").addClass("active");
      $(".c-form__progress").addClass("progress1");
    });
    $(".c-form__group:nth-child(1) .return-txt").on("click", function () {
      $(".c-form__toggle").removeClass("remove");
      $(".c-form__group:nth-child(1)").removeClass("active");
    });

    $(".c-form__group:nth-child(2) .c-form__nextIcon").on("click", function () {
      $(".c-form__group:nth-child(2)").removeClass("active");
      $(".c-form__group:nth-child(3)").addClass("active");
      $(".c-form__progress").addClass("progress2");
    });
    $(".c-form__group:nth-child(2) .return-txt").on("click", function () {
      $(".c-form__group:nth-child(2)").removeClass("active");
      $(".c-form__group:nth-child(1)").addClass("active");
      $(".c-form__progress").removeClass("progress1");
    });

    $(".c-form__group:nth-child(3) .c-form__nextIcon").on("click", function () {
      $(".c-form__group:nth-child(3)").removeClass("active");
      $(".c-formContainer .c-form").addClass("active");
      $(".c-formContainer .c-welcome").addClass("active");
      $(".c-form__progress").addClass("progress3");
      $("h1").css("display", "none");
      $(".last-ttl").css("display", "block");
      $(".user-name").css("display", "none");
    });
    $(".c-form__group:nth-child(3) .return-txt").on("click", function () {
      $(".c-form__group:nth-child(3)").removeClass("active");
      $(".c-form__group:nth-child(2)").addClass("active");
      $(".c-form__progress").removeClass("progress2");
    });
  },
};
</script>
